import { POSImage, POSButton } from '@publicisgroupe/p-os-components';
import { CookieBanner } from 'components/CookieBanner/CookieBanner';
import { canShowCookieBanner } from 'components/CookieBannerModal/CookieBannerHelper';
import { useEffect, useState } from 'react';
import { Container, Grid, Icon, Transition } from 'semantic-ui-react';
import { t } from 'utils/resources';

interface DesktopViewProps {
  showLandscape: boolean;
  showLoginBackground: boolean;
  showLoginContent: boolean;
  backgroundImage: string;
  logo?: string;
  posLogo?: string;
  loginRedirect: () => void;
}
export const LoginDesktopView = ({
  showLandscape,
  showLoginBackground,
  showLoginContent,
  backgroundImage,
  logo,
  posLogo,
  loginRedirect,
}: DesktopViewProps) => {
  const [showCookieBannerModal, setShowCookieBannerModal] = useState<boolean>(false);

  useEffect(() => {
    const show = canShowCookieBanner();
    if (show) {
      setShowCookieBannerModal(show);
    }
  }, []);
  return (
    <Container>
      <div className="desktop-view">
        <div
          className={`${showLandscape ? ' hide-background ' : ''} ${
            showLoginBackground ? ' fadeIn ' : ' fadeOut '
          }`}
        >
          <div
            className="sunset-bg"
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
          ></div>
          <div className={showCookieBannerModal ? 'cookie-content-block' : 'cookie-content-none'}>
            <Grid className="intro-block">
              <Grid.Row columns={2}>
                <Grid.Column width={13}>
                  <Transition.Group animation="fly right" duration={800} directional>
                    {showLoginBackground && showCookieBannerModal && (
                      <div className="cookie-banner">
                        <div className="content">
                          <CookieBanner closeBanner={() => setShowCookieBannerModal(false)} />
                        </div>
                      </div>
                    )}
                  </Transition.Group>
                </Grid.Column>
                <Grid.Column width={1} className="grid-data-secondary"></Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <div className="content-block">
            <Grid
              className={
                showLoginContent ? 'intro-block grid-data fadeIn' : 'intro-block grid-data fadeOut'
              }
            >
              <Grid.Row columns={2}>
                {showCookieBannerModal && <Grid.Column width={5} />}
                <>
                  <Grid.Column width={showCookieBannerModal ? 16 : 7} className="grid-data-primary">
                    {posLogo && (
                      <POSImage
                        src={`${posLogo}`}
                        alt="Logo"
                        className="logo-primary-dark-bg-after"
                      />
                    )}
                    {logo && (
                      <img src={`${logo}`} alt="Logo" className="logo-primary-dark-bg-after" />
                    )}
                    <p className="logo-description">{t('Login.LogoDescription')} </p>
                    <POSButton
                      className="primary-button login-button"
                      onClick={() => loginRedirect()}
                      disabled={showCookieBannerModal}
                    >
                      {t('Login.Button')}
                    </POSButton>
                    <div className="request-access">
                      <p>
                        {t('Login.RequestAccess')}
                        <br />
                        <a href="" onClick={(e) => e.preventDefault()}>
                          {t('Login.BottomContent')}
                        </a>
                        <Icon name="angle right"></Icon>
                      </p>
                    </div>
                  </Grid.Column>
                </>
              </Grid.Row>
            </Grid>
          </div>
        </div>
      </div>
    </Container>
  );
};
